import "core-js/modules/es6.symbol.js";
import "core-js/modules/web.dom.iterable.js";
import "core-js/modules/es6.array.iterator.js";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('span', {
    staticClass: "rating-system d-inline-block"
  }, [_c('span', {
    staticClass: "stars"
  }, _vm._l(_vm.allStars, function (star, index) {
    return _c('MdmIcon', {
      key: "".concat(star, "-").concat(index),
      staticClass: "mr-1",
      class: _objectSpread(_objectSpread({}, _vm.getClassStar(star)), {}, {
        ["".concat(star, "-handler")]: true
      }),
      attrs: {
        "size": _vm.size,
        "name": star
      }
    });
  }), 1)]);
};
var staticRenderFns = [];
export { render, staticRenderFns };